export default "__VITE_ASSET__B_J9qdZV__";